import "react";
import * as dm from "deepmerge";
import { request, RequestError } from "./request.js";
import { isJsonObject } from "./utils.js";
const { all: deepmerge } = { ...dm }.default || dm;
class ApiError extends Error {
  constructor(message, details, statusCode) {
    super(message);
    this.statusCode = statusCode;
    try {
      this.details = JSON.parse(details);
    } catch (err) {
      this.details = details;
    }
  }
}
function createHttp(config, options = {}) {
  async function request$1(url, userOptions = {}) {
    const fetchOptions = deepmerge([options, userOptions]);
    if (!isJsonObject(userOptions.body)) {
      fetchOptions.body = userOptions.body;
    }
    return request(getAbsoluteUrl(url, config), fetchOptions).catch((err) => {
      if (err instanceof RequestError) {
        return Promise.reject(new ApiError(`Request to ${url} failed`, err.body, err.status));
      }
      return Promise.reject(new Error(`Unknown error occured when ${url} requested.`));
    });
  }
  async function get(url, options2) {
    return request$1(url, {
      ...options2,
      method: "GET"
    });
  }
  async function post(url, body, options2) {
    return request$1(url, {
      body,
      ...options2,
      method: "POST"
    });
  }
  async function put(url, body, options2) {
    return request$1(url, {
      body,
      ...options2,
      method: "PUT"
    });
  }
  async function patch(url, body, options2) {
    return request$1(url, {
      body,
      ...options2,
      method: "PATCH"
    });
  }
  async function _delete(url, options2) {
    return request$1(url, {
      ...options2,
      method: "DELETE"
    });
  }
  return {
    request: request$1,
    get,
    post,
    put,
    patch,
    delete: _delete
  };
}
function getAbsoluteUrl(path, config) {
  const { origin } = new URL(config.apiServer);
  return path.startsWith(origin) ? path : `${origin}${path}`;
}
export {
  ApiError,
  createHttp
};
//# sourceMappingURL=http.js.map
